import { useCallback } from "react";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { getColumnsWithGroup } from "../../api/Windows";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetResourcesFields() {
  const setResourceFields = useWorkOrderStore(
    (state) => state.setWoResourcesFields
  );

  const createRequestData = async () => {
    const data = {
      IncludeValidValues: "true",
      IncludeValidValuesExceptions: ["Equipment"],
      IsReadOnly: "true",
      ValidValueFilters: [],
      WindowName: "mob_wo_planning",
      ContextPKey: {
        Plant: await getCurrentPlant(),
        WoBase: "",
        WoTask: "  ",
        WoSubtask: "  ",
      },
    };
    return data;
  };

  const getResourcesFields = useCallback(
    async (woNumber: string) => {
      const reqData = await createRequestData();
      const response = await getColumnsWithGroup(reqData);
      if (!response.isError) {
        const data = response.data;
        if (data.fields && Object.keys(data.fields).length > 0) {
          const fields = [] as any[];
          const keys = Object.keys(data.fields);
          keys.forEach((key) => {
            if (key.includes("wo_resources.")) {
              fields.push(data.fields[key]);
            }
          });
          fields.sort((a, b) => {
            return Number(a.FieldOrder) - Number(b.FieldOrder);
          });
          setResourceFields(woNumber, fields);
        }
      }
      return response;
    },
    [setResourceFields]
  );

  return { getResourcesFields };
}
